import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCourseSettings, fetchUserSettings, updateSettingsAction, saveCourseSettings, saveUserSettings } from '../actions/settingsActions';
import { CourseSettings } from './course-settings';
import { ButtonControl } from './controls';

const SettingsManager = ({ userID, courseID }) => {
  const dispatch = useDispatch();
  const { settings, userCourses, settingsFound } = useSelector((state) => state.settings);
  const [currentID, setCurrentID] = useState(null);
  const [endpoint, setEndpoint] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    // const courseID = params.get('post');
    // const userID = params.get('user_id');

    if (courseID) {
      setCurrentID(parseInt(courseID));
      setEndpoint('course');
      dispatch(fetchCourseSettings(courseID));
    } else if (userID) {
      setCurrentID(parseInt(userID));
      setEndpoint('user');
      dispatch(fetchUserSettings(userID));
    }
  }, [dispatch]);

  const saveSettings = () => {
    if (endpoint === 'course') {
      dispatch(saveCourseSettings(currentID, settings));
    } else {
      dispatch(saveUserSettings(currentID, settings));
    }
  };

  const onSettingsChange = (data) => {
    dispatch(updateSettingsAction(data));
  };

  return (
    <div>
      <div>
        {endpoint === 'course' ? (
          <div>
            {settings && settings.options && Object.keys(settings.options).length > 0 ? (
              <>
                <CourseSettings currentID={currentID} settings={settings} setSettings={onSettingsChange} endpoint={endpoint} />
                <ButtonControl className="mt-5" onClick={saveSettings} label="Save changes" />
              </>
            ) : (
              <div>No solution types available</div>
            )}
          </div>
        ) : (
          <div className="mb-10">
            {settings && settings.length > 0 ? (
              <>
                {settings.map((course, index) => (
                  <div key={index}>
                    {course.options && Object.keys(course.options).length > 0 ? (
                      <CourseSettings
                        currentID={course.id}
                        settings={course}
                        setSettings={onSettingsChange}
                        endpoint={endpoint}
                        name={course.name}
                      />
                    ) : (
                      <div>No solution types available for course {course.name}</div>
                    )}
                  </div>
                ))}
                <ButtonControl className="mt-5" onClick={saveSettings} label="Save changes" />
              </>
            ) : (
              <div>No settings available</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export { SettingsManager };
